import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f0wtyxk4dn: FaireBrandEntity = {
  token: "b_f0wtyxk4dn",
  type: "brand",
  name: "Chesebro's Handmade Confections and Candy",
  avatarUrl:
    "https://cdn.faire.com/fastly/c21ec1eb8b01d9727bd54a726067217f1e1efc14a0947368fa7e32eb31f02f0e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c4f0a9780e29defd77875f15af29adce903d3299993f6ddf9df167ac862f0d3c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c21ec1eb8b01d9727bd54a726067217f1e1efc14a0947368fa7e32eb31f02f0e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c4f0a9780e29defd77875f15af29adce903d3299993f6ddf9df167ac862f0d3c.jpeg",
  location: "Thomasville, NC, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 105,
  isInsider: true,
  description:
    "We trace our candy making roots all the way back to the Davis Candy Company, started in 1910 in Springfield, Missouri! The business has changed hands and names several times over the years but one thing remains constant - our commitment to making quality products for our customers!\n\nWe still use most of the original candy making equipment today - copper pots, gas stoves, wooden paddles and vintage, turn of the century candy making equipment.  You can taste the difference that quality makes!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:33.079Z",
    importedBy: "entity-db-cli",
  },
};
